<template>
    <v-dialog :value="active" max-width="800" persistent>
        <v-card>
            <v-card-title class="text-h6">
                Confirmar período de indisponibilidade
            </v-card-title>

            <v-card-text>
                <v-alert type="info" text dense class="mb-5">
                    O período selecionado conflita com reservas existentes neste hotel.
                    Revise as informações abaixo antes de confirmar.
                </v-alert>

                <v-card v-if="pendingBookings.length > 0" outlined class="mb-4">
                    <v-card-title class="subtitle-2 yellow py-2 px-3">
                        <v-icon left small>mdi-alert-circle-outline</v-icon>
                        Reservas pendentes ({{ pendingBookings.length }})
                    </v-card-title>
                    <v-card-text class="pb-0">
                        Ao confirmar, as reservas abaixo serão <strong>canceladas automaticamente</strong>.
                    </v-card-text>
                    <v-data-table
                        :headers="bookingHeaders"
                        :items="pendingBookings"
                        hide-default-footer
                        dense
                    >
                        <template v-slot:item.check_in="{ item }">
                            {{ formatDate(item.check_in) }}
                        </template>
                        <template v-slot:item.check_out="{ item }">
                            {{ formatDate(item.check_out) }}
                        </template>
                    </v-data-table>
                </v-card>

                <v-card v-if="confirmedBookings.length > 0" outlined>
                    <v-card-title class="subtitle-2 success white--text py-2 px-3">
                        <v-icon left small color="white">mdi-check-circle-outline</v-icon>
                        Reservas confirmadas ({{ confirmedBookings.length }})
                    </v-card-title>
                    <v-card-text class="pb-0">
                        As reservas abaixo já estão confirmadas e <strong>não serão afetadas</strong>.
                    </v-card-text>
                    <v-data-table
                        :headers="bookingHeaders"
                        :items="confirmedBookings"
                        hide-default-footer
                        dense
                    >
                        <template v-slot:item.check_in="{ item }">
                            {{ formatDate(item.check_in) }}
                        </template>
                        <template v-slot:item.check_out="{ item }">
                            {{ formatDate(item.check_out) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="$emit('cancel')">Cancelar</v-btn>
                <v-btn color="orange" :loading="loading" @click="$emit('confirm')">
                    Confirmar e prosseguir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UnavailabilityConflictModal',

    props: {
        active: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        pendingBookings: {
            type: Array,
            default: () => [],
        },
        confirmedBookings: {
            type: Array,
            default: () => [],
        },
    },

    data: () => ({
        bookingHeaders: [
            { text: 'ID',        value: 'id',        sortable: false },
            { text: 'Check-in',  value: 'check_in',  sortable: false },
            { text: 'Check-out', value: 'check_out', sortable: false },
        ],
    }),

    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '';
            const datePart = String(dateStr).substring(0, 10);
            const [year, month, day] = datePart.split('-');
            return `${day}/${month}/${year}`;
        },
    },
};
</script>
